import { useEffect, useState } from 'react';

import { ActionIcon, Transition } from '@mantine/core';

import { IconArrowUp } from '@tabler/icons-react';

export function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button when user scrolls down 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Transition mounted={isVisible} transition="slide-up" duration={200} timingFunction="ease">
      {styles => (
        <ActionIcon
          style={{
            ...styles,
            position: 'fixed',
            bottom: '2rem',
            right: '2rem',
            zIndex: 1000,
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          }}
          size="lg"
          color="wedding.5"
          variant="filled"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <IconArrowUp size={20} />
        </ActionIcon>
      )}
    </Transition>
  );
}
